module.exports = ".notification {\n    padding: 20px;\n    background-color: #f44336; /* Red */\n    color: white;\n    text-align: center;\n    font-size: 20px;\n    margin: 20px 0;\n    border-radius: 5px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/subscription/subscription-list/subscription-list.component.css
// module id = ./src/app/components/subscription/subscription-list/subscription-list.component.css
// module chunks = main